const removeLayers = (map, matches) => {
  const ids = map.getStyle().layers.map(layer => layer.id)
  matches.forEach(match => {
    ids.filter(id => id.includes(match)).forEach(id => {
      try {
        map.getLayer(id) && map.removeLayer(id)
      } catch(error) {
        // console.warn(error)
      }
    })
  })
  // console.log(map.getStyle().layers.map(layer => layer.id))
  
}

export default removeLayers



// WEBPACK FOOTER //
// ./src/utility/removeLayers.js